import { memo } from 'react';
import { Pressable } from 'react-native';
import { Box } from '@bonanza-social/moonlight';
import { ABSOLUTE_FILL_STYLE, BACKDROP_STYLE } from './StatusModal.content';
import { StatusModalProps } from './StatusModal.types';
import StatusChangeHeader from '../StatusChange/StatusChangeHeader/StatusChangeHeader';
import withLandscapeLock from '../../hoc/withLandscapeLock';

function StatusModal({
  headerShown,
  children,
  close,
  ...rest
}: StatusModalProps) {
  return (
    <Box flex={1} paddingVertical="space-300">
      <Pressable style={ABSOLUTE_FILL_STYLE} onPress={close}>
        <div style={BACKDROP_STYLE} />
      </Pressable>
      <StatusChangeHeader
        headerShown={headerShown}
        backgroundColor="transparent"
      />
      <Box
        flex={{
          mobile: 1,
          tablet: undefined,
          desktop: undefined,
        }}
        maxWidth={{
          mobile: '100%',
          tablet: 375,
          desktop: 375,
        }}
        paddingTop="space-600"
        paddingBottom="space-300"
        margin="auto"
        {...rest}
      >
        {children}
      </Box>
    </Box>
  );
}

export default memo(withLandscapeLock(StatusModal));
